import React, { useState, useEffect } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Pagination,
  Stack,
  Paper,
  Checkbox,
  Tooltip,
  Button,
  TextField,
  Chip,
} from "@mui/material";
import ScaleLoader from "react-spinners/ScaleLoader";
import noTableData from "../../assets/images/noTableData.svg";
import API from "../../utils/Axios.utils";
import useStyles from "../../assets/styles/SupMangComp.style";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const SupplierDetails = ({
  handleDialog,
  setAlert,
  setAlertType,
  setAlertContent,
  JobId,
}) => {
  const classes = useStyles();
  const [showLoader, setShowLoader] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  //   checkbox
  const [selected, setSelected] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  // existing states
  const [searchText, setSearchText] = useState("");
  // Pagination
  // To do set total data count of api
  const [supplierData, setSupplierData] = useState([]);
  const [listCount, setListCount] = useState(0);
  const [page, setPage] = useState(1);

  const handlePageChange = (e, value) => {
    setPage(value);
  };

  const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getSupplier = async () => {
    let url = `api/users/assign_supplier_list?JobId=${JobId}&page=${page}&pageSize=10`;
    if (searchText.trim()) {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }
    try {
      const res = await API.get(url, config);
      setSupplierData(res?.data?.result);
      setListCount(res?.data?.totalCount);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getSupplier();
  }, [page, searchText]);

  const handleSelectAll = (event) => {
    const selectedIds = event.target.checked
      ? supplierData
        .filter((val) => !val.checked) // Filter out suppliers with checked=true
        .map((val) => val.supplier_id)
      : [];

    setSelectAll(event.target.checked);
    setSelected(selectedIds);
  };

  console.log("selected", selected);

  const handleClick = (event, supplierID) => {
    // Toggle selection
    const selectedIndex = selected.indexOf(supplierID);
    let newSelected = [];

    if (selectedIndex === -1) {
      // If supplierID is not already selected, add it to the selected list
      newSelected = [...selected, supplierID];
    } else {
      // If already selected, remove it from the list
      newSelected = selected.filter((id) => id !== supplierID);
    }

    // Filter out the supplier IDs from selected whose checked status is true in supplierData
    newSelected = newSelected.filter(
      (id) =>
        !supplierData.find((supplier) => supplier.supplier_id === id)?.checked
    );

    setSelected(newSelected);
  };

  const handleSubmit = async () => {
    const data = {
      JobId,
      supplierIds: selected,
    };
    if (selected.length === 0) {
      setIsFormSubmitted(true);
    } else {
      try {
        setShowLoader(true);
        const res = await API.post(
          "/api/users/supplier/sendmail",
          data,
          config
        );
        setIsFormSubmitted(false);
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
        setShowLoader(false);

        handleDialog();
      } catch (error) {
        setShowLoader(false);
        setIsFormSubmitted(false);
        setAlertContent(error?.response?.data?.message);
        setAlertType("error");
        setAlert(true);
      }
    }
  };

  const allChecked = supplierData.every((val) => val.checked);
  const [sortOrder, setSortOrder] = useState("asc");
  // Separate handlers for ascending and descending sort
  const sortAsc = () => {
    const sortedData = [...supplierData].sort((a, b) =>
      (a.org_name || "").toLowerCase() > (b.org_name || "").toLowerCase() ? 1 : -1
    );
    setSupplierData(sortedData);
    setSortOrder("asc");
  };

  const sortDesc = () => {
    const sortedData = [...supplierData].sort((a, b) =>
      (a.org_name || "").toLowerCase() < (b.org_name || "").toLowerCase() ? 1 : -1
    );
    setSupplierData(sortedData);
    setSortOrder("desc");
  };

  return (
    <div>
      <Grid container xs={12}>
        {/* <Grid
          item
          xs={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className={classes.headingText}>Supplier</span>
        </Grid> */}
        <Grid container xs={12} alignItems="center" justifyContent="space-between">
          <Grid item>
            <span className={classes.headingText}>Supplier</span>
          </Grid>
          <Grid item>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search Supplier"
              value={searchText}
              onChange={(e) => {
                setPage(1); // reset to first page on new search
                setSearchText(e.target.value);
              }}
              style={{ minWidth: 200 }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} className={classes.tableGrid}>
        {showLoader ? (
          <div
            style={{
              display: "flex",
              height: 400,
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <ScaleLoader size={250} color={"#0576DC"} loading={showLoader} />
          </div>
        ) : supplierData.length === 0 ? (
          <div
            style={{
              height: 300,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={noTableData} width={60} alt="No Data" />
            <div
              style={{
                marginTop: 5,
                fontWeight: "500",
                fontSize: 25,
                fontFamily: "'Noto Sans', sans-serif",
              }}
            >
              There are no recent Suppliers to show.
            </div>
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow className={classes.tableHeadRow}>
                  <TableCell className={classes.tableHeadCell}>
                    <Checkbox
                      checked={selectAll || allChecked}
                      onChange={handleSelectAll}
                      sx={{
                        "&.Mui-checked": {
                          color: "#ffff",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Supplier Name
                  </TableCell>
                  {/* <TableCell className={classes.tableHeadCell}>
                    Organisation Name
                  </TableCell> */}
                  <TableCell className={classes.tableHeadCell} style={{ userSelect: "none", whiteSpace: "nowrap" }}>
                    Organisation Name
                    <span style={{ float: "right", display: "flex", flexDirection: "row", cursor: "pointer" }}>
                      <ArrowUpwardIcon
                        fontSize="small"
                        color={sortOrder === "asc" ? "primary" : "inherit"}
                        onClick={sortAsc}
                      />
                      <ArrowDownwardIcon
                        fontSize="small"
                        color={sortOrder === "desc" ? "primary" : "inherit"}
                        onClick={sortDesc}
                      />
                    </span>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>Core Skills</TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    Preferredflag
                  </TableCell>
                </TableRow>
              </TableHead>
              <>
                <TableBody className={classes.noHorizontalBorderTableRow}>
                  {supplierData.map((val) => {
                    return (
                      <TableRow key={val.supplier_id}>
                        <TableCell className={classes.tableBodyCell}>
                          <Checkbox
                            color="primary"
                            checked={
                              val.checked || selected.includes(val.supplier_id)
                            }
                            onClick={(event) =>
                              handleClick(event, val.supplier_id)
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.name}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {val.org_name}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell} >
                          {val?.jobCoreSkill?.length > 0 ? (
                            <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ maxWidth: '200px' }}>
                              {val.jobCoreSkill.slice(0, 3).map((skill) => (
                                <Chip
                                  key={skill.id}
                                  label={skill.name}
                                  size="small"
                                  sx={{
                                    fontSize: '0.75rem',
                                    height: '24px',
                                    '& .MuiChip-label': { paddingLeft: '8px', paddingRight: '8px' }
                                  }}
                                />
                              ))}
                              {val.jobCoreSkill.length > 3 && (
                                <Chip
                                  label={`+${val.jobCoreSkill.length - 3}`}
                                  size="small"
                                  color="default"
                                  sx={{
                                    fontSize: '0.75rem',
                                    height: '24px',
                                    '& .MuiChip-label': { paddingLeft: '6px', paddingRight: '6px' }
                                  }}
                                />
                              )}
                            </Stack>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        {/* <TableCell className={classes.tableBodyCell}>
                          {val?.skill?.length <= 3 ? (
                            <Tooltip title={val?.skill?.join(", ")} arrow>
                              {val?.skill?.join(", ")}
                            </Tooltip>
                          ) : (
                            <>
                              <Tooltip title={val?.skill?.join(", ")} arrow>
                                {val?.skill?.slice(0, 3).join(", ")}
                                <span>...</span>
                              </Tooltip>
                            </>
                          )}
                        </TableCell> */}
                        <TableCell>
                          {val.preffered_supplier === "Y" ? "Yes" : "No"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </>
            </Table>
            <Stack
              spacing={2}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <Pagination
                classes={{
                  root: classes.pagination,
                }}
                count={Math.ceil(listCount / 10)}
                page={page}
                onChange={handlePageChange}
                showFirstButton
                showLastButton
              />
            </Stack>
          </TableContainer>
        )}
      </Grid>
      {isFormSubmitted && selected.length === 0 && (
        <div
          style={{
            color: "red",
            marginLeft: "14px",
            fontWeight: 400,
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          select one of the row
        </div>
      )}
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "15px",
          }}
        >
          <Button
            variant="contained"
            aria-haspopup="true"
            style={{
              background: "#2777AA",
              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: "500",
              letterSpacing: 1,
            }}
            onClick={handleSubmit}
            disabled={showLoader}
          >
            Submit
          </Button>
        </div>
      </Grid>
    </div>
  );
};

export default SupplierDetails;
